import { StatisticsResource, statisticsResource } from '@/resources/statistics.resource';
import { AbstractModule } from './abstract.module';

/**
 * Moduł statystyk
 *
 * @export
 * @class StatisticsModule
 * @extends {AbstractModule<StatisticsResource>}
 */
export class StatisticsModule extends AbstractModule<StatisticsResource> {
  public state = { procedure: undefined, attachment: undefined };

  public actions = {
    /**
     * Pobiera statystyki procedury
     *
     * @param {*} context
     * @param {*} args
     * @returns {Promise<any>}
     */
    getProcedureStatistics: (context: any, args: any): Promise<any> =>
      this.resource.procedureStatistics(args).then(statistics => {
        context.commit('saveProcedureStatistics', statistics);
        return statistics;
      }),

    /**
     * Pobiera statystyki dokumentacji
     *
     * @param {*} context
     * @param {*} args
     * @returns {Promise<any>}
     */
    getAttachmentStatistics: (context: any, args: any): Promise<any> =>
      this.resource.generatedAttachmentsStatistics(args).then(statistics => {
        context.commit('saveAttachmentStatistics', statistics);
        return statistics;
      })
  };

  public mutations = {
    /**
     * Zapisuje statystyki procedury
     *
     * @param {*} localState
     * @param {*} statistics
     */
    saveProcedureStatistics: (localState: any, statistics: any): void => {
      localState.procedure = statistics;
    },
    /**
     * Zapisuje statystyki dokumentacji
     *
     * @param {*} localState
     * @param {*} statistics
     */
    saveAttachmentStatistics: (localState: any, statistics: any): void => {
      localState.attachment = statistics;
    }
  };

  constructor() {
    super(statisticsResource);
  }
}

export default new StatisticsModule();
